module.exports = __webpack_public_path__ + "img/banner-spirit.4e0e20cf.png";